export default {
  id: "default",
  name: "default",
  grid: [
    { "id": "d982acf5-a78a-4f7e-b16a-2bc7adbe27f5", "x": 0, "y": 0, "w": 6, "h": 4, "minW": 2, "minH": 1, "pos": 1, "content": "2 x 1", "name": null, "type": null, "data": null },
    { "id": "79c9ac8d-8785-464d-ac21-5de35c4a6aec", "x": 6, "y": 0, "w": 6, "h": 4, "minW": 2, "minH": 1, "pos": 2, "content": "2 x 1", "name": null, "type": null, "data": null },
    { "id": "85b0570d-e309-4975-93d5-d0f1531b9692", "x": 0, "y": 4, "w": 6, "h": 4, "minW": 2, "minH": 1, "pos": 3, "content": "2 x 1", "name": null, "type": null, "data": null },
    { "id": "3460763e-66b8-4550-aeb2-67fa721708e0", "x": 6, "y": 4, "w": 6, "h": 4, "minW": 2, "minH": 1, "pos": 4, "content": "2 x 1", "name": null, "type": null, "data": null }
  ]
};
